import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_OLYMPIC_QUESTION,
  ADD_UPDATE_OLYMPIC,
  AddOlympicQuestionAction,
  AddUpdateOlympicAction,
  DELETE_OLYMPIC,
  DELETE_OLYMPIC_QUESTION,
  DeleteOlympicAction,
  DeleteOlympicQuestionAction,
  GET_OLYMPIC,
  GET_OLYMPICS,
  GET_OLYMPIC_PARTICIPANTS,
  GET_OLYMPIC_QUESTION,
  GET_QUESTIONS_BY_OLYMPIC,
  GetOlympicAction,
  GetOlympicParticipantsAction,
  GetOlympicQuestionAction,
  GetOlympicsAction,
  GetQuestionsByOlympicAction,
  UPDATE_OLYMPIC_QUESTION,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE,
  UpdateOlympicQuestionAction,
  UploadOlympicQuestionDisplayImageAction,
} from "./actionTypes";

import {
  addOlympicQuestion,
  addUpdateOlympic,
  deleteOlympic,
  deleteOlympicQuestion,
  getOlympic,
  getOlympicParticipants,
  getOlympicQuestion,
  getOlympics,
  getQuestionsByOlympic,
  updateOlympicQuestion,
  uploadOlympicQuestionDisplayImage,
} from "../../helpers/backend_helper";
import {
  addOlympicQuestionError,
  addOlympicQuestionSuccess,
  addUpdateOlympicError,
  addUpdateOlympicSuccess,
  deleteOlympicError,
  deleteOlympicQuestionError,
  deleteOlympicQuestionSuccess,
  deleteOlympicSuccess,
  getOlympicError,
  getOlympicParticipantsError,
  getOlympicParticipantsSuccess,
  getOlympicQuestionError,
  getOlympicQuestionSuccess,
  getOlympicSuccess,
  getOlympicsError,
  getOlympicsSuccess,
  getQuestionsByOlympicError,
  getQuestionsByOlympicSuccess,
  updateOlympicQuestionError,
  updateOlympicQuestionSuccess,
  uploadOlympicQuestionDisplayImageError,
  uploadOlympicQuestionDisplayImageSuccess,
} from "./actions";

function* getOlympicQuestionSaga({
  payload: { id, history },
}: GetOlympicQuestionAction) {
  try {
    const response: ResponseGenerator = yield call(getOlympicQuestion, id);
    yield put(getOlympicQuestionSuccess(response.data));
  } catch (error) {
    yield put(getOlympicQuestionError(error));
  }
}

function* addOlympicQuestionSaga({
  payload: { request, history },
}: AddOlympicQuestionAction) {
  try {
    yield call(addOlympicQuestion, request);
    yield put(addOlympicQuestionSuccess());
  } catch (error) {
    yield put(addOlympicQuestionError(error));
  }
}

function* updateOlympicQuestionSaga({
  payload: { id, request, history },
}: UpdateOlympicQuestionAction) {
  try {
    yield call(updateOlympicQuestion, id, request);
    yield put(updateOlympicQuestionSuccess());
  } catch (error) {
    yield put(updateOlympicQuestionError(error));
  }
}

function* deleteOlympicQuestionSaga({
  payload: { id, history },
}: DeleteOlympicQuestionAction) {
  try {
    yield call(deleteOlympicQuestion, id);
    yield put(deleteOlympicQuestionSuccess());
  } catch (error) {
    yield put(deleteOlympicQuestionError(error));
  }
}

function* getQuestionsByOlympicSaga({
  payload: { query },
}: GetQuestionsByOlympicAction) {
  try {
    const response: ResponseGenerator = yield call(
      getQuestionsByOlympic,
      query
    );
    yield put(getQuestionsByOlympicSuccess(response.data));
  } catch (error) {
    yield put(getQuestionsByOlympicError(error));
  }
}

function* uploadOlympicQuestionDisplayImageSaga({
  payload: { file, history, questionId },
}: UploadOlympicQuestionDisplayImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadOlympicQuestionDisplayImage,
      file,
      questionId
    );
    yield put(uploadOlympicQuestionDisplayImageSuccess(response.data));
  } catch (error) {
    yield put(uploadOlympicQuestionDisplayImageError(error));
  }
}

function* addUpdateOlympicSaga({
  payload: { history, request },
}: AddUpdateOlympicAction) {
  try {
    yield call(addUpdateOlympic, request);
    yield put(addUpdateOlympicSuccess());
  } catch (error) {
    yield put(addUpdateOlympicError(error));
  }
}

function* getOlympicSaga({ payload: { id, history } }: GetOlympicAction) {
  try {
    const response: ResponseGenerator = yield call(getOlympic, id);
    yield put(getOlympicSuccess(response.data));
  } catch (error) {
    yield put(getOlympicError(error));
  }
}

function* getOlympicsSaga({ payload: { query } }: GetOlympicsAction) {
  try {
    const response: ResponseGenerator = yield call(getOlympics, query);
    yield put(getOlympicsSuccess(response.data));
  } catch (error) {
    yield put(getOlympicsError(error));
  }
}

function* deleteOlympicSaga({ payload: { id } }: DeleteOlympicAction) {
  try {
    yield call(deleteOlympic, id);
    yield put(deleteOlympicSuccess());
  } catch (error) {
    yield put(deleteOlympicError(error));
  }
}

function* getOlympicParticipantsSaga({
  payload: { request, history },
}: GetOlympicParticipantsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getOlympicParticipants,
      request as PaginateQuery
    );
    yield put(getOlympicParticipantsSuccess(response.data));
  } catch (error) {
    yield put(getOlympicParticipantsError(error));
  }
}

function* OlympicSaga() {
  yield takeEvery(GET_OLYMPIC_QUESTION, getOlympicQuestionSaga);
  yield takeEvery(ADD_OLYMPIC_QUESTION, addOlympicQuestionSaga);
  yield takeEvery(UPDATE_OLYMPIC_QUESTION, updateOlympicQuestionSaga);
  yield takeEvery(DELETE_OLYMPIC_QUESTION, deleteOlympicQuestionSaga);
  yield takeEvery(GET_QUESTIONS_BY_OLYMPIC, getQuestionsByOlympicSaga);
  yield takeEvery(
    UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE,
    uploadOlympicQuestionDisplayImageSaga
  );
  yield takeEvery(ADD_UPDATE_OLYMPIC, addUpdateOlympicSaga);
  yield takeEvery(GET_OLYMPIC, getOlympicSaga);
  yield takeEvery(GET_OLYMPICS, getOlympicsSaga);
  yield takeEvery(DELETE_OLYMPIC, deleteOlympicSaga);
  yield takeEvery(GET_OLYMPIC_PARTICIPANTS, getOlympicParticipantsSaga);
}

export default OlympicSaga;
